module.exports = __webpack_public_path__ + "img/1.8230c908.jpg";